/*
 * @Author: HS
 * @Date: 2022-02-14 15:49:30
 * @LastEditors: DQL
 * @LastEditTime: 2022-06-25 10:16:30
 * @Description: file content
 */
const njglRoutes = {
  path: 'njgl',
  name: 'njgl',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'njyqSq/:jqjlId?',
      name: 'njyqSq',
      component: () =>
        import(
        /* webpackChunkName:"njyqSq" */ '@/features/attendance/njgl/njyqSq.vue'
        ),
      meta: {
        navtabTitle: '年假延期申请',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'njyqSqcg/:processInsId',
      name: 'njyqSqcg',
      component: () =>
        import(
        /* webpackChunkName:"njyqSqcg" */ '@/features/attendance/njgl/njyqSq.vue'
        ),
      meta: {
        navtabTitle: '年假延期申请',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'njyqSqcgBack/:processInsId/:condition',
      name: 'njyqSqcgBack',
      component: () =>
        import(
        /* webpackChunkName:"njyqSqcgBack" */ '@/features/attendance/njgl/njyqSq.vue'
        ),
      meta: {
        navtabTitle: '年假延期申请',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'njffqkCx',
      name: 'njffqkCx',
      component: () =>
        import(
        /* webpackChunkName:"njffqkCx" */ '@/features/attendance/njgl/njffqkCx.vue'
        ),
      meta: {
        navtabTitle: '年假发放情况查询',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'grnjCx',
      name: 'grnjCx',
      component: () =>
        import(
        /* webpackChunkName:"grnjCx" */ '@/features/attendance/njgl/grnjCx.vue'
        ),
      meta: {
        navtabTitle: '个人年假查询',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'njsqyqSp/:processInsId/:taskId',
      name: 'njsqyqSp',
      component: () =>
        import(
          /* webpackChunkName: "njsqSp" */ '@/features/attendance/njgl/njsqyqSp.vue'
        ),
      meta: {
        navtabTitle: '年假申请延期审批',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'njsqSpResult/:processInsId/:taskId',
      name: 'njsqSpResult',
      component: () =>
        import(
          /* webpackChunkName: "njsqSpResult" */ '@/features/attendance/njgl/njsqyqSp.vue'
        ),
      meta: {
        navtabTitle: '年假申请延期审批',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'njview/:processInsId/:taskId?',
      name: 'njview',
      component: () =>
        import(
          /* webpackChunkName: "njview" */ '@/features/attendance/njgl/view.vue'
        ),
      meta: {
        navtabTitle: '年假申请延期明细',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    }
  ]
};
export default njglRoutes;
